import { Image } from 'expo-image';
import { StyleSheet, TouchableOpacity, View } from 'react-native';

import { ChatRoom } from '@/api/models/chatRoomModels';
import { bs_icon } from '@/assets/images';
import { profilePlaceholder } from '@/assets/images/icons';
import { useAuth } from '@/contexts/authContext';
import { firebaseImage, safeJsonParseArray } from '@/utils/firebaseImage';

import Text from '../Text';

interface ChatRoomProps {
  chatRoom: ChatRoom;
  onPress: () => void;
}

const ChatRoomCard = ({ chatRoom, onPress }: ChatRoomProps) => {
  const { state: auth } = useAuth();

  const thumbnail = chatRoom.thumbnail
    ? firebaseImage(safeJsonParseArray(chatRoom.thumbnail ?? '[]')?.at(0))
    : auth.user?.user.role === 'INDIVIDUAL'
      ? bs_icon
      : profilePlaceholder;

  return (
    <TouchableOpacity onPress={onPress}>
      <View style={styles.mainContainer}>
        <View style={styles.innerContainer}>
          <Image source={thumbnail} placeholder={bs_icon} placeholderContentFit="contain" style={styles.thumbnail} />
          <View style={styles.textContainer}>
            <Text fontWeight="700" style={styles.colorBlack}>
              {chatRoom.title}
            </Text>
            <Text>{chatRoom.subtitle}</Text>
            <Text>{chatRoom.footer}</Text>
          </View>
        </View>
        {/* <Text style={styles.date}>{formatChatDate(chatRoom.date)}</Text> */}
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  mainContainer: { flexDirection: 'row', justifyContent: 'space-between' },

  innerContainer: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 10
  },

  thumbnail: {
    width: 40,
    height: 40,
    borderRadius: 20
  },

  textContainer: {
    gap: 5
  },

  colorBlack: {
    color: 'black'
  },

  date: {
    fontSize: 12
  }
});

export default ChatRoomCard;
